import { render, staticRenderFns } from "./FixPriceRoutes.vue?vue&type=template&id=61d02633&"
import script from "./FixPriceRoutes.vue?vue&type=script&lang=js&"
export * from "./FixPriceRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports